// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"127":"07c85e61","132":"6e27a16f","140":"c0287fdc","157":"0ca6d8f2","446":"c49e6f35","449":"fc74607c","573":"68cc5211","574":"c9635a46","742":"beaa2a0f","801":"afa74ae2","995":"6bfb177a"}[chunkId] + ".chunk.js";
};